import { observer, inject } from 'mobx-react';
import * as React from 'react';

import './dashboard.css';
import PageFrameGeneric from '../../common/page-frames/generic';
import UserStore from '../../stores/UserStore';

interface DashboardProps {
  history: any,
  userStore?: UserStore
}

@inject('userStore')
@observer
class Dashboard extends React.Component<DashboardProps> {
  public constructor(props: DashboardProps) {
    super(props);
  }

  public componentWillMount() {
    const userStore = this.props.userStore!;
    if (!userStore.isSignedIn) {
      this.props.history.push('/sign-in');
    }

    if (userStore.canUpdate) {
      this.props.history.push('/user-info');
    }
  }

  public render() {
    return (
      <PageFrameGeneric
          title="Dashboard"
      >
        <div className="container dashboard has-background-white">
          <div className="columns is-centered">
              <div className="column is-8 has-text-centered">
                <i className="no-match-icon far fa-clock"/>
              </div>
            </div>
            <div className="columns is-centered">
              <div className="column is-8 has-text-centered">
                <p className="title is-size-3">Tick-tock, tick-tock...</p>
                <p className="subtitle is-size-5">
                  Sorry, we haven't found a match yet 😢
                </p>
                <p className="subtitle is-size-6">
                  Our algorithm is hard at work finding you the best mentor.<br/>
                  Please come back and check with us later!
                </p>
              </div>
            </div>
        </div>
      </PageFrameGeneric>
    );
  }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/pages/dashboard/Dashboard.tsx